<template>
    <div>
        <CCard
            v-if="filtersSet.store_id.value || filtersSet.name.value || filtersSet.product_group_id.value"
            style="width: 220px;height: auto;overflow-y: scroll;padding: 10px;display: flex;margin-bottom: 5px;"
            class="scroll-bar"
        >
            <div v-for="(item, index) in Object.keys(filtersSet)" :key="index">
                <p
                    v-if="filtersSet[item].value"
                    style="font-size: 15px;display: flex;align-items: center;gap:5px;font-weight: 800;cursor: pointer;"
                    class="mb-2"
                    @click="filters[item] = '', filterMe(), filtersSet[item].value = ''"
                >
                    <FaIcon icon="times" class="text-danger" />
                    <span
                        class="text-primary"
                    >{{ filtersSet[item].label }} : {{ filtersSet[item].value }}</span>
                </p>
            </div>
        </CCard>
        <CCard
            style="width: 220px;height: auto;overflow-y: scroll;padding: 10px;margin-bottom: 5px;"
            class="scroll-bar"
        >
            <NameInput @emitName="filterMe" />
            <label style="display: flex;font-size: 12px;gap: 5px">
                <CSwitch
                    color="primary"
                    size="sm"
                    variant="3d"
                    style="margin-bottom: 10px;"
                    :checked="filters.has_discount === true"
                    @update:checked="hasDiscountSwitch"
                />
                <span>{{ $t('product.only_discounted_products') }}</span>
            </label>
            <label style="display: flex;font-size: 12px;gap: 5px">
                <CSwitch
                    color="primary"
                    size="sm"
                    variant="3d"
                    style="margin-bottom: 10px;"
                    :checked="filters.in_stock === 1"
                    @update:checked="inStockSwitch"
                />
                <span>{{ $t('product.only_available_products') }}</span>
            </label>
            <RangeInput @emitRange="filterMe" />
        </CCard>
        <StoreSearch @emitStore="filterMe" :selectableStores="selectableStores" />
        <!-- <GroupSearch @emitGroup="filterMe" /> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import { NameInput, RangeInput, StoreSearch, GroupSearch } from '../components'
import { NameInput, RangeInput, StoreSearch } from '../components'

export default {
    name: 'ProductFilter',

    components: {
        NameInput,
        RangeInput,
        StoreSearch,
        // GroupSearch
    },

    props: {
        selectableStores: {
            default: [],
        }
    },

    computed: {
        ...mapGetters({
            pagination: 'product/pagination',
            filtersSet: 'product/filtersSet',
            filters: 'product/filters',
        }),
    },

    methods: {
        ...mapActions({
            fetchProduct: 'product/fetch',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        inStockSwitch() {
            this.filters.in_stock = !this.filters.in_stock ? 1 : ''
            this.filterMe()
        },
        hasDiscountSwitch() {
            this.filters.has_discount = !this.filters.has_discount ? true : ''
            this.filterMe()
        },
        filterMe() {
            this.setShowLoading()
            this.fetchProduct({
                page: 1,
                ...this.filters,

            }).then(() => {
                this.setShowLoading(false)
            })
            this.pagination.page = 1
        },
    },
}
</script>
<style scoped>
.scroll-bar::-webkit-scrollbar {
    display: none;
}
</style>